import { render, staticRenderFns } from "./PortinView.vue?vue&type=template&id=b58b1bf8&"
import script from "./PortinView.vue?vue&type=script&lang=js&"
export * from "./PortinView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports